export default "__VITE_ASSET__f2b4d4d2__"